module.exports = __webpack_public_path__ + "5a60c50e7ec99ae2b8d846fe45aaca8c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/aoe_logo_final_right.png
// module id = 146
// module chunks = 0